import {createContext, useState, useEffect, useCallback, useRef} from '@wordpress/element';
import {useCardFieldEvents} from "../hooks";

export const CreditCardContext = createContext(null);

export const CreditCardProvider = ({data, children}) => {
    const [errors, setErrors] = useState({});
    const [paymentMethodData, setPaymentMethodData] = useState({});
    const currentData = useRef({paymentMethodData});
    const [validatedFields, setValidatedFields] = useState({
        cvv: {
            isValid: false,
            isEmpty: true
        },
        expiry: {
            isValid: false,
            isEmpty: true
        },
        number: {
            isValid: false,
            isEmpty: true
        }
    });
    const [cardElement, setCardElement] = useState(null);
    const [cardFields, setCardFields] = useState({});
    const cardFieldRefs = useRef({});

    const addPaymentMethodData = useCallback((data) => {
        setPaymentMethodData(prev => ({
            ...prev,
            ...data
        }));

        currentData.current.paymentMethodData = {
            ...currentData.current.paymentMethodData,
            ...data
        };
    }, []);

    const getPaymentMethodData = useCallback(() => {
        return currentData.current.paymentMethodData;
    }, []);

    const cardFieldRef = useCallback((key) => (ref) => {
        if (ref) {
            cardFieldRefs.current = {
                ...cardFieldRefs.current,
                [key]: ref
            }
        }
    });

    const onFieldError = useCallback((key) => {
        setErrors(prev => ({
            ...prev,
            [key]: getErrorCode(key)
        }))
    }, []);

    const onRemoveError = useCallback((key) => {
        setErrors(prev => {
            delete prev[key];
            return {...prev};
        });
    }, []);

    const setValidatedField = useCallback((key, field) => {
        setValidatedFields(prev => ({
            ...prev,
            [key]: field
        }))
    }, []);

    const {
        events,
    } = useCardFieldEvents({
        setValidatedField,
        onError: onFieldError,
        onRemoveError,
        cardFields,
        cardFieldRefs: cardFieldRefs.current
    });

    const context = {
        i18n: data.i18n,
        events,
        errors,
        onFieldError,
        cardFields,
        cardFieldRef,
        cardFieldRefs,
        cardElement,
        setCardFields,
        setCardElement,
        validatedFields,
        paymentMethodData,
        addPaymentMethodData,
        getPaymentMethodData
    }

    return (
        <CreditCardContext.Provider value={context}>
            {children}
        </CreditCardContext.Provider>
    )
};

const getErrorCode = (key) => {
    let code;
    switch (key) {
        case 'number':
            code = 'INVALID_NUMBER';
            break;
        case 'expiry':
            code = 'INVALID_EXPIRY';
            break;
        case 'cvv':
            code = 'INVALID_CVV';
            break;
    }
    return code;
}